@if (accomplishments.length > 0 || awards.length > 0) {
  <h2 class="mat-headline-4 mb-8 text-center">
    {{ 'marketReports.recognition.header' | transloco }}
  </h2>
  @if (awards.length > 0) {
    <div class="mb-8 rounded-b shadow-lg print:break-inside-avoid print:bg-steel-5 print:shadow-none">
      <div class="banner flex justify-center rounded bg-blue-100 bg-cover">
        @if (awardsLogoImage) {
          <img class="h-16 py-2" [src]="awardsLogoImage" [alt]="'Agent of the Year Awards ' + awardYear" />
        }
      </div>
      <div class="my-4 flex flex-wrap pb-8">
        @for (award of awards; track award) {
          <rma-market-report-award class="xxl:w-1/4 my-2 w-full px-4 md:w-1/2 print:w-1/2" [award]="award" />
        }
      </div>
    </div>
  }
  <div class="flex flex-wrap print:break-inside-avoid">
    @for (item of accomplishments; track item) {
      <div class="xxl:w-1/4 w-full rounded p-4 md:w-1/2 print:w-1/2 print:p-0">
        <rma-profile-accomplishment-item class="block rounded p-4 print:mb-4 print:bg-steel-5" [accomplishment]="item" />
      </div>
    }
  </div>
}
